import React from 'react';
import { Outlet } from 'react-router-dom';
import AppLayout from './AppLayout';

const LayoutWrapper = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default LayoutWrapper;





